export enum ValueType {
  Any = 0,
  AlphaNumeric = 1,
  Integer = 2,
  Decimal = 3,
  Email = 4,
  MultipleEmail = 5,
  MobileNumber = 6,
  UserName = 7,
  Url = 8,
  Barcode = 9
}
